import { create } from "zustand";
import { type Stage } from "@/modules/ServiceCore/types";

interface ServiceWorkflowState {
  serviceId: "autotables" | "autojam" | null;
  serviceType: "auto_table" | "auto_jam" | null;
  pId?: string;
  initTableId?: string;
  onTokenAddedCallback: ((supplierId: string) => void) | null;
  initStage?: Stage;
  stage: Stage;
  history: Stage[];

  setWorkflowState: (params: Partial<ServiceWorkflowState>) => void;
  setPId: (pId: string) => void;
  navigateToStage: (newStage: Stage) => void;
  replaceStage: (newStage: Stage) => void;
  navigateBack: () => boolean;
}

export const useServiceWorkflowStore = create<ServiceWorkflowState>(
  (set, get) => ({
    serviceId: null,
    serviceType: null,
    pId: undefined,
    initTableId: undefined,
    onTokenAddedCallback: null,
    initStage: undefined,
    stage: "loading",
    history: ["loading"],

    setWorkflowState: (params) => set((state) => ({ ...state, ...params })),
    setPId: (pId) => set({ pId }),

    navigateToStage: (newStage: Stage) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      set((state) => ({
        stage: newStage,
        history: [...state.history, newStage],
      }));
    },

    replaceStage: (newStage: Stage) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      set((state) => {
        const newHistory = [...state.history];
        newHistory[newHistory.length - 1] = newStage;
        return {
          stage: newStage,
          history: newHistory,
        };
      });
    },

    navigateBack: () => {
      const { history, stage } = get();
      if (history.length > 1 && stage !== "status") {
        set({
          history: history.slice(0, -1),
          stage: history[history.length - 2],
        });
        return true;
      }
      return false;
    },
  }),
);
